module.exports = __webpack_public_path__ + "img/search.5bddc73f.svg";